import { ValueOf } from '@/types/typings';

export const SearchSource = {
  search: 'search',
  filters: 'filters',
  form: 'form',
} as const;

export type SearchSource = ValueOf<typeof SearchSource>;

export type Sort = {
  field: string;
  ascending: boolean;
};

export const MealType = {
  undefined: 'Undefined',
  ro: 'RO',
  bf: 'BF',
  bb: 'BB',
  hb: 'HB',
  fb: 'FB',
  ai: 'AI',
  uai: 'UAI',
  custom: 'Custom',
  bbf: 'BBF', // Завтрак «Шведский стол»
  cbf: 'CBF', // Завтрак «Континентальный»
  ebf: 'EBF', // Завтрак «Английский»
  lu: 'LU', // Обед
  di: 'DI', // Ужин
  fbb: 'FBB', // Полный пансион «Шведский стол»
  fbc: 'FBC', // Полный пансион «Заказное меню»
  bd: 'BD', // Ужин «Шведский стол»
  dc: 'DC', // Ужин «Заказное меню»
  cu: 'CU', // Свой тип питания
  hbl: 'HBL', // Полупансион: завтрак и обед
  hbd: 'HBD', // Полупансион: завтрак и ужин
  abf: 'ABF', // Завтрак «Американский»
  hbld: 'HBLD', // Полупансион: обед и ужин
} as const;

export type MealType = ValueOf<typeof MealType>;

export const PropertyType = {
  undefined: 'Undefined',
  hotel: 'HOTEL',
  apartment: 'APARTMENT',
  hostel: 'HOSTEL',
  guest_house: 'GUEST_HOUSE',
  villa: 'VILLA',
  resort: 'RESORT',
  'b&b': 'B&B',
  motel: 'MOTEL',
  cottage: 'COTTAGE',
  cabin: 'CABIN',
  holiday_park: 'HOLIDAY_PARK',
  camping: 'CAMPING',
  cruise: 'CRUISE',
  ryokan: 'RYOKAN',
  riad: 'RIAD',
} as const;

export type PropertyType = ValueOf<typeof PropertyType>;

export type Filters = {
  stars?: number[];
  mealTypes?: MealType[];
  accommodationTypes?: PropertyType[];
  minPrice?: number;
  maxPrice?: number;
};

export type SearchParams = {
  cityId: string;
  adults: number;
  arrivalDate: string;
  departureDate: string;
  childAges?: number[];
};

export type FiltersPayloud = Filters & SearchParams;

export interface Address {
  countryCode: string;
  postCode: string;
  region: string | null;
  regionId: string | null;
  addressLine: string;
  cityId: string;
  cityName: string;
  latitude: number;
  longitude: number;
}

export type AccommodationItem = {
  id: string;
  externalId: string;
  holderId: string;
  externalHolderId: string;
  systemId: string;
  name: string;
  address: Address;
  lowestPrice: number;
  images: { url: string }[];
  propertyType: PropertyType;
  stars: number;
  rating: number;
  reviewsCount?: number;
  mealTypes: MealType[];
};

export type OperationItem = {
  position: number | null;
  toPosition: number | null;
  fromPosition: number | null;
  item: AccommodationItem | null;
};

export type SubscribePayload = {
  sort: Sort[];
  filters: FiltersPayloud;
  start: number;
  size: number;
};

interface Operation {
  type: 'ANSWER' | 'CLEAN' | 'INSERT' | 'MOVE' | 'UPDATE' | 'DELETE';
  item: OperationItem;
}

export type SearchResponse = {
  sessionId: string;
  operations: Operation[];
  status: {
    text: string;
    code: number;
  };
  searchKey: string;
  error: {
    text: string;
    errors: { key: string; value: string }[];
  } | null;
};

export interface FetchMorePayload {
  sessionKey: string;
  page: number;
  pageSize: number;
}
